import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";

export const GetCorporateCustomers = async ({
  limit = DEFAULT_LIMIT,
  offset = 0,
  status = "",
  corporate_name = ""
}) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(
    `corporate-customers?limit=${limit}&offset=${offset}&status=${status}&corporate_name=${corporate_name}`,
    options
  );
};
